import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EnterpriseTemplate from "@/components/templates/EnterpriseTemplate";
import { TRUST, TRUST_INDEX } from "@/data/pages";
import { listArticles } from "@/lib/api";

export default function TrustPage() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";
  const [articles, setArticles] = useState([]);
  const modules = t("modules.list", { returnObjects: true }) || [];

  useEffect(() => {
    listArticles(lang).then(setArticles).catch(() => {});
  }, [lang]);

  const entry = TRUST[slug];
  if (!entry) return <Navigate to={`/${lang}/trust`} replace />;
  const data = entry[lang] || entry.en;
  const meta = TRUST_INDEX.find((x) => x.slug === slug);

  return (
    <EnterpriseTemplate
      data={data}
      path={`/trust/${slug}`}
      lang={lang}
      seoTitle={meta ? `${meta[lang].title} — Trust Center` : "Trust Center"}
      articles={articles}
      modules={modules}
    />
  );
}
